module.exports = __webpack_public_path__ + "img/icon-ban-light.7cc014d7.svg";